"use client";

import {
  CROSS_SELL_V2_BADGE,
  CROSS_SELL_V2_CTA,
  type CrossSellOfferCopy,
} from "@/libs/cross-sell-v2";
import { CROSS_SELL_CTA_TEXT, CROSS_SELL_SHELL_BG } from "@/components/cross-sell/cross-sell-shell";
import { useCrossSellImpression } from "@/hooks/useCrossSellTracking";
import { useCrossSellClickAction } from "@/hooks/useCrossSellClickAction";
import CrossSellComingSoonModal from "@/components/cross-sell/CrossSellComingSoonModal";

type CrossSellSitewideBannerProps = {
  offer: CrossSellOfferCopy;
};

const ctaClassName =
  "inline-flex shrink-0 items-center rounded-full bg-white px-3 py-1 text-xs font-bold whitespace-nowrap transition-opacity hover:opacity-90";

export default function CrossSellSitewideBanner({ offer }: CrossSellSitewideBannerProps) {
  useCrossSellImpression(offer.id, "sitewide");
  const { teaseOpen, handleClick, closeTease, ctaUrl } = useCrossSellClickAction(
    offer.id,
    "sitewide",
    offer.ctaUrl,
  );

  return (
    <>
      <div
        data-promo-banner
        data-cross-sell-offer={offer.id}
        className="relative z-50 flex items-center justify-center border-b border-white/10 px-3 sm:px-6"
        style={{
          height: "40px",
          background: CROSS_SELL_SHELL_BG,
        }}
      >
        <div className="flex w-full max-w-6xl items-center justify-center gap-2 sm:gap-3 text-sm text-white">
          <span className="inline-flex shrink-0 items-center rounded-full bg-white/10 px-2 py-0.5 text-[0.65rem] font-black tracking-wide backdrop-blur-sm sm:px-2.5 sm:text-xs">
            {CROSS_SELL_V2_BADGE}
          </span>

          <span className="min-w-0 text-center text-xs font-medium leading-tight text-white/90 sm:text-sm">
            <span className="sm:hidden">{offer.sitewideMobile}</span>
            <span className="hidden sm:inline">{offer.sitewideDesktop}</span>
          </span>

          {ctaUrl ? (
            <a
              href={ctaUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleClick}
              className={ctaClassName}
              style={{ color: CROSS_SELL_CTA_TEXT }}
            >
              {CROSS_SELL_V2_CTA}
            </a>
          ) : (
            <button
              type="button"
              onClick={handleClick}
              className={ctaClassName}
              style={{ color: CROSS_SELL_CTA_TEXT }}
            >
              {CROSS_SELL_V2_CTA}
            </button>
          )}
        </div>
      </div>

      <CrossSellComingSoonModal offer={offer} open={teaseOpen} onClose={closeTease} />
    </>
  );
}
